"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const oneEntry_1 = require("../base/oneEntry");
/**
 * Controllers for working with types
 */
class GeneralTypesApi extends oneEntry_1.default {
    constructor(url, token) {
        super(url, token);
        this._url += '/api/content/general-types';
    }
    /**
     * Get all types.
     *
     * @returns Returns all objects of type GeneralTypeEntity
     */
    async getAllTypes() {
        const result = await this._fetchGet('');
        return result;
    }
}
exports.default = GeneralTypesApi;
